module.exports = __webpack_public_path__ + "Roboto-BlackItalic.ac9a922232bb34219e80.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-BlackItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-BlackItalic.woff
// module chunks = styles